const norm = s => String(s || '').trim().toLowerCase();
const text = s => String(s || '').replace(/\r\n?/g, '\n');
const nsKey = l => norm(l.item) === 'generic budgetary item' ? (l.display_name || l.memo?.split('\n')[0] || l.item) : l.item;

// Match repeated SKUs one-to-one, not by an aggregate that hides line edits.
export function buildQuoteDiff(nsLines, builderLines) {
  const queues = new Map();
  nsLines.forEach((line, index) => {
    const key = norm(nsKey(line));
    if (!queues.has(key)) queues.set(key, []);
    queues.get(key).push({ line, index });
  });
  const added = [], removed = [], changed = [];
  let same = 0;
  builderLines.forEach(b => {
    const old = queues.get(norm(b.key))?.shift();
    if (!old) { added.push(b); return; }
    const a = old.line;
    const fields = [];
    if (Math.abs((a.qty || 0) - b.qty) > 0.001) fields.push('Quantity');
    if (Math.abs((a.rate || 0) - b.unit) > 0.005) fields.push('Price');
    [['desc', 'memo', 'Description'], ['displayName', 'display_name', 'Display name'], ['lineRef', 'line_ref', 'Line ref'], ['notes', 'notes', 'W/O notes']].forEach(([bk, ak, label]) => {
      if (b[bk] !== undefined && text(b[bk]) !== text(a[ak])) fields.push(label);
    });
    if (fields.length) changed.push({ ...b, oldQty: a.qty || 0, oldUnit: a.rate || 0, fields });
    else same += 1;
  });
  queues.forEach(queue => queue.forEach(({ line: a }) => removed.push({ key: nsKey(a), qty: a.qty || 0, unit: a.rate || 0 })));
  const reordered = nsLines.length === builderLines.length && nsLines.some((l, i) => norm(nsKey(l)) !== norm(builderLines[i].key));
  return { added, removed, changed, same, reordered, order: builderLines.map(l => l.key) };
}